import moment from 'moment';
import { Card } from 'primereact/card';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import BannerComponent from '../components/BannerComponent';
import CustomDialog from '../components/CustomDialog';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import MenuItemIcon from '../components/MenuItemIcon';
import TooltipComponent from '../components/TooltipComponent';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import { currency } from '../components/utils/CurrencyUtils';
import BlockUi from '../components/waitPanel/BlockUi';
import AccountService from '../services/AccountService';
import InvoiceService from '../services/InvoiceService';
import ProfileService from '../services/ProfileService';
import StartPageService from '../services/StartPageService';
import OrderCardDialog from './OrderCardDialog';
import SettingService from '../services/SettingService';
import { CarouselComponent } from '../components/CarouselComponent';
import CardService from '../services/CardService';

class StartContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.accountService = new AccountService();
        this.invoiceService = new InvoiceService();
        this.startPageService = new StartPageService();
        this.profileService = new ProfileService();
        this.settingService = new SettingService();
        this.cardService = new CardService();
        this.user = this.authService.getProfile();
        this.state = {
            balance: {},
            tooltipVisibile: false,
            permissionBalanceTooltipVisibile: false,
            permissionProfileTooltipVisibile: false,
            permissionFleetCardsTooltipVisibile: false,
            permissionInvoiceTooltipVisibile: false,
            lastInvoiceAmount: {},
            loading: false,
            loadingBalance: true,
            loadingNewsfeed: true,
            loadingNewsfeedError: false,
            loadingUnpaidInvoices: true,
            loadingLastInvoice: true,
            blocking: false,
            list: [],
            coordinate: 0,
            unpaidInvoices: { toPayAmount: 0, count: 0 },
            showTopUpDialog: false,
            topUpDialogConfirmation: false,
            topUpAmount: undefined,
            orderCardVisibile: false,
            invoiceTraditionalDialog: false,
            paymentRecipient: 'Anwim S.A. ul. Stańczyka 3, 01-237 Warszawa',
            tfcVisible: true,
            addTrustedDeviceDialog: false,
            banners: [],
            activeBannerIndex: 0,
            bannerSwitchTime: 5000,
            bannerProgress: 0,
            approvals: [],
        };
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleShowTooltipMenuItem = this.handleShowTooltipMenuItem.bind(this);
        this.hideBanner = this.hideBanner.bind(this);
        this.renderNewsCard = this.renderNewsCard.bind(this);
        this.renderTopUpDialog = this.renderTopUpDialog.bind(this);
        this.handleOrderCardDialogOpen = this.handleOrderCardDialogOpen.bind(this);
        this.handleOrderCardDialogClose = this.handleOrderCardDialogClose.bind(this);
        this.handleHideNoPermissionTooltip = this.handleHideNoPermissionTooltip.bind(this);
        this.handleShowNoPermissionTooltip = this.handleShowNoPermissionTooltip.bind(this);
    }

    componentDidMount() {        
        super.componentDidMount();
        this.readMessage();
        this.settingService
            .getValue('BANNER_SWITCH_TIME')
            .then((resp) => {
                this.setState(
                    {
                        bannerSwitchTime: resp.value,
                    }
                );
            });

        const { t } = this.props;
        if (this.user && this.user.agreementType === 'CASH' && this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES')) {
            this.invoiceService
                .getLastInvoice()
                .then((lastInvoiceAmount) => {
                    this.setState({ lastInvoiceAmount, loadingLastInvoice: false });
                })
                .catch(() => {
                    this.setState({ loadingLastInvoice: false });
                    this.showErrorMessage(t('error.getLastInvoiceAmount'));
                });
        } else if (
            this.user &&
            (((this.user.agreementType === 'CASHLESS' || this.user.agreementType === 'PREPAID') &&
                this.isUserHasAnyPermission('PERMISSION_VIEW_START', 'PERMISSION_EDIT_START')) ||
                this.user.agreementSapRole === 'HURT' ||
                this.user.agreementSapRole === 'FRANCZYZA' ||
                this.user.agreementSapRole === 'HURT EPT')
        ) {
            this.accountService
                .getBalance()
                .then((balance) => {
                    this.setState({ balance, loadingBalance: false });
                })
                .catch(() => {
                    this.setState({ loadingBalance: false });
                    this.showErrorMessage(t('error.getBalanceError'));
                });
        } else {
            this.setState({ loadingLastInvoice: false, loadingBalance: false });
        }
        if (
            this.user &&
            ((this.user.agreementSapRole === 'FLOTA' && this.isUserHasAnyPermission('PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE')) ||
                this.user.agreementSapRole === 'HURT' ||
                this.user.agreementSapRole === 'FRANCZYZA' ||
                this.user.agreementSapRole === 'HURT EPT')
        ) {
            this.profileService
                .getRecipientAndBankName()
                .then((response) => {
                    this.setState({
                        paymentRecipient: response.recipient,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileRecipientAndBankNameError'));
                });
        }
        if (
            this.user &&
            ((this.user.agreementType === 'CASHLESS' && this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES')) ||
                this.user.agreementSapRole === 'HURT' ||
                this.user.agreementSapRole === 'FRANCZYZA' ||
                this.user.agreementSapRole === 'HURT EPT')
        ) {
            this.invoiceService
                .getUnpaidList()
                .then((data) => {
                    if (this._isMounted) {
                        this.setState({
                            unpaidInvoices: data,
                            loadingUnpaidInvoices: false,
                        });
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            unpaidInvoices: { toPayAmount: 0, count: 0 },
                            loadingUnpaidInvoices: false,
                        });
                        this.showErrorMessage(t('error.getInvoicesError'));
                    }
                });
        } else {
            this.setState({ loadingUnpaidInvoices: false });
        }
        this.startPageService
            .getNewsfeed()
            .then((response) => {
                this.setState({
                    newsfeed: response.content,
                    newsURL: response.newsUrl,
                    loadingNewsfeed: false,
                    loadingNewsfeedError: false,
                });
            })
            .catch(() => {
                this.setState({ loadingNewsfeed: false, loadingNewsfeedError: true });
                this.showErrorMessage(t('error.getNewsfeedError'));
            });
        this.startPageService
            .getOfferForYou()
            .then((response) => {
                this.setState({
                    offerForYouUrl: response.url,
                    offerForYouImage: response.imageName,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getOfferForYouError'));
            });
        this.startPageService
            .getPragmaBanner()
            .then((response) => {
                this.setState({
                    pragmaUrl: response.url,
                    pragmaImage: response.imageName,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getOfferForYouError'));
            });
        this.startPageService
            .getBanners()
            .then((response) => {
                this.setState({
                    banners: response.banners
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getBannersError'));
            });
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE')) {
            this.checkIfDeviceAlreadyAddedToTrusted();
        }

        if (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK') {
            this.getHybridCardUserApprovalsToAccept();
        }
    }

    getHybridCardUserApprovalsToAccept() {
        this.cardService.getHybridCardUserApprovalsToAccept()
            .then((response) => this.setState({ approvals: response }))
            .catch((error) => {
                this.showErrorMessage("Wystąpił błąd podczas pobierania regulaminów dla uzytkownika karty hybrydowej")
            })
    }

    getOnlyNotAcceptedHybridCardUserApprovals() {
        const listOfAcceptedTerms = this.authService.getHybridCardUserAcceptedTerms();
        return this.state.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId));
    }


    checkIfDeviceAlreadyAddedToTrusted() {
        const { t } = this.props;
        let currentDeviceIdent = this.profileService.generateDeviceUuid();
        if(!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
        this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
        this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
        this.authService.getProfile().helpdeskUserRole === 'HOTLINE')) {
            this.profileService.getTrustedDevices(this.user?.userAgreementMapId)
            .then((res) => {
                if (res.trustedDeviceList.length > 0) {
                    if(res.trustedDeviceList.filter(d => d.deviceIdent === currentDeviceIdent).length > 0) {
                        console.log("Urzadzenie to jest na liście zaufanych. ")
                        this.setState({ addTrustedDeviceDialog: false });
                    }
                    else {
                        console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                        this.setState({ addTrustedDeviceDialog: true });
                    }
                } else {console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                    this.setState({ addTrustedDeviceDialog: true });}
            })
            .catch(() => {
                this.showErrorMessage(t('error.profileTrustedDevicesError'));
            })
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    handleShowTooltip() {
        this.setState({ tooltipVisibile: true });
    }

    handleHideTooltip() {
        this.setState({ tooltipVisibile: false });
    }
    handleShowNoPermissionTooltip(element) {
        if (element === 'BALANCE') {
            this.setState({ permissionBalanceTooltipVisibile: true });
        }
        if (element === 'PROFILE') {
            this.setState({ permissionProfileTooltipVisibile: true });
        }
        if (element === 'CARDS') {
            this.setState({ permissionFleetCardsTooltipVisibile: true });
        }
        if (element === 'INVOICE') {
            this.setState({ permissionInvoiceTooltipVisibile: true });
        }
    }

    handleHideNoPermissionTooltip(element) {
        if (element === 'BALANCE') {
            this.setState({ permissionBalanceTooltipVisibile: false });
        }
        if (element === 'PROFILE') {
            this.setState({ permissionProfileTooltipVisibile: false });
        }
        if (element === 'CARDS') {
            this.setState({ permissionFleetCardsTooltipVisibile: false });
        }
        if (element === 'INVOICE') {
            this.setState({ permissionInvoiceTooltipVisibile: false });
        }
    }

    handleShowTooltipMenuItem() {
        this.setState({ tooltipVisibile: true });
    }

    hideBanner() {
        this.setState({ renderBanner: false });
    }

    handleOrderCardDialogOpen() {
        this.setState({ orderCardVisibile: true });
    }

    handleOrderCardDialogClose(callback) {
        this.setState({ orderCardVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    renderNoPermissionToOpenTooltip(element) {
        const { t } = this.props;
        return <div className='tooltip-label permission-info'>
            <TooltipComponent
                id={`permission-tooltip-label-id-${element}`}
                key={`permission-tooltip-label-id-${element}`}
                visible={
                    (this.state.permissionBalanceTooltipVisibile && element === 'BALANCE') ||
                    (this.state.permissionProfileTooltipVisibile && element === 'PROFILE') ||
                    (this.state.permissionFleetCardsTooltipVisibile && element === 'CARDS') ||
                    (this.state.permissionInvoiceTooltipVisibile && element === 'INVOICE')
                }
                content={t('error.permissionTooltip')}
                eventListeners={[
                    {
                        eventName: 'mouseleave',
                        fnc: () => this.handleHideNoPermissionTooltip(element),
                        eventElementId: `ico_help_permission_label_id-${element}`,
                    },
                    {
                        eventName: 'mouseenter',
                        fnc: () => this.handleShowNoPermissionTooltip(element),
                        eventElementId: `ico_help_permission_label_id-${element}`,
                    },
                ]}
            />
            <span className='p-label flex-inputs'>

                <MenuItemIcon
                    alt=''
                    key={`menu-item-key-${element}`}
                    id={`ico_help_permission_label_id-${element}`}
                    className='icon-svg right-label flex-inputs'
                    iconSvg={'ico_help_input_label_blue'}
                    eventListeners={[
                        {
                            eventName: 'mouseenter',
                            fnc: () => this.handleShowNoPermissionTooltip(element),
                            eventElementId: `ico_help_permission_label_id-${element}`,
                        },
                    ]}
                />

            </span>
        </div>
    }

    readMessage() {
        const messageSwitchCbk = this.readCookie('switchCbkError');
        if (messageSwitchCbk !== undefined && messageSwitchCbk != null) {
            const message = JSON.parse(messageSwitchCbk);
            this.removeCookie('switchCbkError');
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }

    renderTopUpDialog() {
        const { t } = this.props;
        return (
            <div className='row center-all'>
                <div className='col-12'>
                    {this.state.topUpDialogConfirmation ? (
                        <span className='top-up-confirmed'>{t('balance.topUpTextConfirmed')}</span>
                    ) : (
                        <span>{t('balance.topUpText')}</span>
                    )}
                </div>
                <InputNumberComponent
                    id='topUpAmount'
                    name='topUpAmount'
                    label={t('balance.amount')}
                    value={this.state.topUpAmount}
                    validator={this.validator}
                    validators='required'
                    onChange={this.handleChange}
                    viewMode='EDIT'
                    min={0}
                    max={15000}
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    inputStyle={{ width: '100%' }}
                    colClass='col-md-6 col-sm-12'
                    rendered={this.state.topUpDialogConfirmation}
                    placeholder='0'
                    stateField=''
                />
                <div className='col-12'></div>
                <div className='col-width-auto'>
                    <ActionButton
                        label={this.state.topUpDialogConfirmation ? t('balance.topUpButtonConfirmed') : t('balance.topUpButton')}
                        handleClick={(e) => {
                            e.preventDefault();
                            if (this.state.topUpDialogConfirmation) {
                                this.topUpAccount(this.state.topUpAmount);
                            } else {
                                this.setState({
                                    topUpDialogConfirmation: true,
                                });
                            }
                        }}
                        variant='button blue'
                    />
                </div>
            </div>
        );
    }
    handleAddToTrustedDevice() {
        let generatedDeviceUuid = this.authService.generateDeviceUuid();
        this.profileService
            .addTrustedDevice(generatedDeviceUuid, this.user?.userAgreementMapId)
            .then((res) => {
                if (res === true) {
                    this.showSuccessMessage("Dodano urządzenie do zaufanych");
                    this.saveCookie('startAfterLoginCookie', false);
                    this.setState({ addTrustedDeviceDialog: false });
                }
            })
            .catch(() => {
                this.showErrorMessage("Nie udało się dodać urządzenia do zaufanych");
            });
    }

    render() {
        let startAfterLoginCookie = false;
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') &&
            this.readCookie('startAfterLoginCookie') === 'true') {
            startAfterLoginCookie = true;
        }
        const { t } = this.props;
        return (
            <DivContainer colClass='container-fluid start-page'>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader} key='block-ui'>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} key='custom-messages' />
                    {!this.state.loadingUnpaidInvoices && (this.authService.getProfile().helpdeskUserRole !== 'REGIONAL_MANAGER' &&
                            this.authService.getProfile().helpdeskUserRole !== 'SALES_REPRESENTATIVE' )? (
                        this.state.unpaidInvoices?.toPayAmount > 0 ? (
                            this.renderUnpaidBanner()
                        ) : this.user && this.user.agreementType ? (
                            <BannerComponent
                                key={'header-banner'}
                                label={t('agreement.agreementType')}
                                iconSvg='ico_blue_banner_icon'
                                iconSide='left'
                                subLabel={
                                    this.user && this.user.agreementType === 'CASHLESS'
                                        ? t('profile.cashlessInfoBanner')
                                        : this.user && this.user.agreementType === 'PREPAID'
                                            ? t('profile.prepaidInfoBanner')
                                            : this.user &&
                                                (this.user.agreementSapRole === 'HURT' ||
                                                    this.user.agreementSapRole === 'FRANCZYZA' ||
                                                    this.user.agreementSapRole === 'HURT EPT')
                                                ? t('profile.wholeSaleInfoBanner')
                                                : t('profile.cashInfoBanner')
                                }
                                closeable
                                handleHide={this.hideBanner}
                                rendered={this.state.renderBanner}
                            />
                        ) : null
                    ) : null}
                    {(this.state.addTrustedDeviceDialog && startAfterLoginCookie === true) && <CustomDialog
                        name='add-trusted-dialog'
                        className='add-trusted-device'
                        header="Dodawanie urządzenia do zaufanych"
                        visible={this.state.addTrustedDeviceDialog}
                        viewMode={'VIEW'}
                        onHide={() => {
                            //  this.authService.logout();
                            this.saveCookie('startAfterLoginCookie', false);
                            this.setState({
                                addTrustedDeviceDialog: false,
                                //renderCodeVerificationPage: true
                                //user: undefined,
                            });
                        }}
                        closeable
                    >
                        <div className='codeDialog-text'>
                            <label>{"W przypadku dodania urządzenia do zaufanych podawanie kodu weryfikacyjnego przy kolejnych logowaniach nie będzie wymagane."} </label>
                        </div>
                        <div className='col-width-auto codeBtn'>
                            <ActionButton
                                label={"Dodaj"}
                                variant='blue'
                                // className='edit-blue-link'
                                handleClick={() => this.handleAddToTrustedDevice()}
                                disabled={this.state.captchaPreventAction}
                            />
                        </div>

                    </CustomDialog>}


                    <CustomDialog
                        name='invoice-traditional-dialog'
                        className='confirm-dialog-width'
                        visible={this.state.invoiceTraditionalDialog}
                        viewMode={'VIEW'}
                        onHide={() => {
                            this.setState({ invoiceTraditionalDialog: false });
                        }}
                        modal
                        header={t('invoice.payTraditional')}
                    >
                        <Card
                            footer={() => (
                                <div className='footer-dialog-button-container'>
                                    <ActionButton
                                        label={t('details.close')}
                                        variant='button save-button'
                                        handleClick={(e) => {
                                            e.preventDefault();
                                            this.setState({ invoiceTraditionalDialog: false });
                                        }}
                                        key={'traditional-dialog-close'}
                                    />
                                </div>
                            )}
                        >
                            <div>
                                <div className='invoice-property desc'>{this.isUserInRole('ROLE_ESPPOL') ? t('invoice.invoiceTraditional.esppol'): t('invoice.invoiceTraditional.desc')}</div>
                                <div className='invoice-property'>
                                    <span className='bold'>{`${t('invoice.invoiceTraditional.recepient')}:`}</span>
                                    <div className='invoice-property-value'>{this.state.paymentRecipient}</div>
                                </div>
                                <div className='invoice-property bank-account'>
                                    <span className='bold'>{`${t('invoice.invoiceTraditional.bankAccount')}:`}</span>
                                    <div className='invoice-property-value'>
                                        {this.user.agreementBankAccountNumber}
                                        <CopyToClipboard
                                            text={
                                                !!this.user.agreementBankAccountNumber
                                                    ? this.user.agreementBankAccountNumber.replace(/^\D+/g, '')
                                                    : ''
                                            }
                                            onCopy={() => this.showSuccessMessage(t('balance.copyBankAccountSuccess'))}
                                        >
                                            <img src='/images/ico_copy.svg' className='card-icon' alt={t('balance.copyBankAccount')} />
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </CustomDialog>
                    <OrderCardDialog
                        onHide={() => this.handleOrderCardDialogClose()}
                        visible={this.state.orderCardVisibile}
                        key='order-card-dialog'
                        agreementsToAccept={this.getOnlyNotAcceptedHybridCardUserApprovals()} 
                        className='order-card-dialog'
                    />
                    <CustomDialog
                        key='start-top-up-dialog'
                        name='start-top-up-dialog'
                        className='start-top-up-dialog'
                        visible={this.state.showTopUpDialog}
                        viewMode={this.props.viewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                            })
                        }
                        onHide={() => {
                            this.setState({
                                showTopUpDialog: false,
                                topUpDialogConfirmation: false,
                            });
                        }}
                        modal
                        header={<label>{t('balance.topUpAccount')}</label>}
                    >
                        {this.renderTopUpDialog()}
                    </CustomDialog>
                    <DivContainer colClass='dashboard' key='render-detials-key'>
                        {this.state.loading ? null : (
                            <form onSubmit={this.handleFormSubmit} noValidate>
                                {this.renderDetails()}
                            </form>
                        )}
                    </DivContainer>
                </BlockUi>
            </DivContainer>
        );
    }

    renderBalanceHeader() {
        const { t } = this.props;
        const hasBalanceAccess = this.user && (
            (this.user.agreementSapRole === 'FLOTA' && this.isUserHasPermission('PERMISSION_EDIT_START')) ||
            this.user.agreementSapRole === 'HURT' ||
            this.user.agreementSapRole === 'FRANCZYZA' ||
            this.user.agreementSapRole === 'HURT EPT'
        );
        const balanceLink =
            this.user && this.user.agreementType === 'PREPAID'
                ? '#/balance-prepaid'
                : this.user.agreementType === 'CASHLESS'
                    ? '#/balance-cashless'
                    : '#/balance';
        const balanceHeaderItems = [
            {
                label: t('balance.label'),
                type: 'LABEL',
                className: 'float-left',
                iconSvg: 'ico_wallet',
            },
            hasBalanceAccess && {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    <div className='button-click-area' onClick={() => (window.location.href = balanceLink)}>
                        <MenuItemIcon
                            alt=''
                            key={'ico_to_balance_details_icon-key'}
                            id='ico_to_balance_details_icon'
                            className='icon-svg balance-details-icon'
                            iconSvg={'ico_balance_details'}
                        />
                    </div>
                ),
            },
            !hasBalanceAccess && {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    this.renderNoPermissionToOpenTooltip('BALANCE')
                ),
            },
        ].filter(Boolean);
        return this.prepareHeader(balanceHeaderItems);
    }

    renderProfileHeader() {
        const { t } = this.props;
        const hasProfileAccess = this.user && (
            (this.user.agreementSapRole === 'FLOTA' && this.isUserHasPermission('PERMISSION_EDIT_START') &&
                this.isUserHasAnyPermission('PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE')) ||
            this.user.agreementSapRole === 'HURT' ||
            this.user.agreementSapRole === 'FRANCZYZA' ||
            this.user.agreementSapRole === 'HURT EPT'
        );
        const headerItems = [
            {
                label: t('profile.label'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_profile',
            },
            hasProfileAccess && {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    <div className='button-click-area' onClick={() => (window.location.href = '#/profile')}>
                        <MenuItemIcon
                            alt=''
                            key={'ico_to_profile_details_icon-key'}
                            id='ico_to_profile_details_icon'
                            className='icon-svg balance-details-icon'
                            iconSvg={'ico_balance_details'}
                        />
                    </div>
                ),
            },
            !hasProfileAccess && {
                type: 'LABEL',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    this.renderNoPermissionToOpenTooltip('PROFILE')
                ),
            },
        ].filter(Boolean);
        return this.prepareHeader(headerItems);
    }

    renderInvoiceHeader() {
        const { t } = this.props;
        const hasInvoiceAccess = this.user && (
            (this.user.agreementSapRole === 'FLOTA' && this.isUserHasPermission('PERMISSION_EDIT_START') &&
                this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES')) ||
            this.user.agreementSapRole === 'HURT' ||
            this.user.agreementSapRole === 'FRANCZYZA' ||
            this.user.agreementSapRole === 'HURT EPT'
        );
        const headerItems = [
            {
                label: t('invoice.listName'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_profile_invoice',
            },
            hasInvoiceAccess && {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    <div className='button-click-area' onClick={() => (window.location.href = '#/invoice-list')}>
                        <MenuItemIcon
                            alt=''
                            key={'ico_to_profile_details_icon-key'}
                            id='ico_to_profile_details_icon'
                            className='icon-svg balance-details-icon'
                            iconSvg={'ico_balance_details'}
                        />
                    </div>
                ),
            },
            !hasInvoiceAccess && {
                type: 'LABEL',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    this.renderNoPermissionToOpenTooltip('INVOICE')
                ),
            },
        ].filter(Boolean);
        return this.prepareHeader(headerItems);
    }

    renderFleetCardsHeader() {
        const { t } = this.props;
        const hasFleetCardsAccess = this.user && (
            (this.user.agreementSapRole === 'FLOTA' && this.isUserHasPermission('PERMISSION_EDIT_START') &&
                this.isUserHasAnyPermission('PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS')) ||
            this.user.agreementSapRole === 'HURT' ||
            this.user.agreementSapRole === 'FRANCZYZA' ||
            this.user.agreementSapRole === 'HURT EPT'
        );
        const headerItems = [
            {
                label: t('fleet.card'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_profile_invoice',
            },
            hasFleetCardsAccess && {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    <div className='button-click-area' onClick={() => (window.location.href = '#/cards')}>
                        <MenuItemIcon
                            alt=''
                            key={'ico_to_profile_details_icon-key'}
                            id='ico_to_profile_details_icon'
                            className='icon-svg balance-details-icon'
                            iconSvg={'ico_balance_details'}
                        />
                    </div>
                ),
            },
            !hasFleetCardsAccess && {
                type: 'LABEL',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () => (
                    this.renderNoPermissionToOpenTooltip('CARDS')
                ),
            },
        ].filter(Boolean);
        return this.prepareHeader(headerItems);
    }

    renderNewsHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('news.label'),
                type: 'LABEL',
                className: 'float-left',
                iconSvg: 'ico_calendar',
            },
            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                customRenderFunction: () =>
                    this.state.newsURL ? (
                        <div className='button-click-area' onClick={() => window.open(this.state.newsURL)}>
                            <MenuItemIcon
                                alt=''
                                key={'ico_to_newsfeed_icon-key'}
                                id='ico_to_newsfeed_details_icon'
                                className='icon-svg balance-details-icon'
                                iconSvg={'ico_balance_details'}
                            />
                        </div>
                    ) : null,
            },
        ];

        return this.prepareHeader(headerItems);
    }

    renderOffersHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('offer.forYou'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_rocket',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    initPayment(invoice) {
        this.blockUi();
        const requestBody = {
            invoiceNumber: invoice?.invoiceNumber,
            paymentType: 'INVOICE',
            amount: invoice?.toPayAmount,
            country: null,
            language: null,
            currency: null,
        };
        this.invoiceService
            .p24PaymentToken(requestBody)
            .then((data) => {
                window.open(data.token, '_blank');
                this.unblockUi();
            })
            .catch(() => {
                this.unblockUi();
                this.messages.show({
                    severity: 'error',
                    summary: 'Błąd',
                    detail: 'Nie udało się zainicjalizować płatności',
                });
            });
    }

    topUpAccount(amount) {
        this.blockUi();
        const popup = window.open('', '_blank')
        const requestBody = {
            invoiceNumber: null,
            paymentType: 'PREPAID',
            amount: amount,
            country: null,
            language: null,
            currency: null,
        };
        this.invoiceService
            .p24PaymentToken(requestBody)
            .then((data) => {
                 if(popup){
                    popup.location.href = data.token;
                }
                this.unblockUi();
            })
            .catch(() => {
                if (popup && !popup.closed) {
                    popup.close();
                }
                this.unblockUi();
                this.messages.show({
                    severity: 'error',
                    summary: 'Błąd',
                    detail: 'Nie udało się zainicjalizować płatności',
                });
            });
        this.setState({
            showTopUpDialog: false,
            topUpAmount: undefined,
            topUpDialogConfirmation: false,
        });
    }

    renderUnpaidBanner() {
        const { t } = this.props;
        const { unpaidInvoices } = this.state;
        if (!!unpaidInvoices && unpaidInvoices.toPayAmount > 0) {
            if (unpaidInvoices.count === 1) {
                const payDate = new Date(unpaidInvoices.payDate);
                return (
                    <BannerComponent
                        key={'header-banner'}
                        label={t('profile.unpaidInvoice')}
                        iconSvg='ico_red_banner_alert_icon'
                        iconSide='left'
                        subLabel={
                            unpaidInvoices.payDate && moment(new Date()).isAfter(payDate)
                                ? t('profile.unpaidInfoAfterPaymentDate', {
                                    invoiceNumber: unpaidInvoices.invoiceNumber,
                                    date: moment(payDate).format('DD-MM-YYYY'),
                                })
                                : t('profile.unpaidInfoBeforePaymentDate', {
                                    invoiceNumber: unpaidInvoices.invoiceNumber,
                                    date: moment(payDate).format('DD-MM-YYYY'),
                                })
                        }
                        rendered={this.state.renderBanner}
                        variant='red-banner'
                        ignoreRightIconItems
                    >
                        <ActionButton
                            key={`pay-invoice-button`}
                            // variant={'button blue pay-invoice-button'}
                            variant={`button ${
                              ((( !unpaidInvoices.sapDocument || (unpaidInvoices?.toPayAmount > 0 &&  unpaidInvoices?.invoiceGrossAmount > 15000)) && this.isUserInRole('ROLE_FLEET')) ||
                               (( !unpaidInvoices.sapDocument || unpaidInvoices.toPayAmount >= 15000) && !this.isUserInRole('ROLE_FLEET')) || (unpaidInvoices.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')))
                                    ? 'pay-invoice-traditional-button'
                                    : (((unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && unpaidInvoices.invoiceGrossAmount <= 15000) && this.isUserInRole('ROLE_FLEET')) ||
                                        ((unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && unpaidInvoices.toPayAmount < 15000) && !this.isUserInRole('ROLE_FLEET'))
                                    )
                                        ? 'pay-invoice-button'
                                        : ''
                                }`}
                            iconSvg={
                                ((unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && unpaidInvoices.invoiceGrossAmount < 15000 && this.isUserInRole('ROLE_FLEET') ) ||
                                ( unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && unpaidInvoices.toPayAmount < 15000 && !this.isUserInRole('ROLE_FLEET'))
                                ) && (!this.isUserInRole('ROLE_ESPPOL'))
                                    ? 'ico_right_arrow_white'
                                    : undefined
                            }
                            iconSide='left'
                            label={
                                unpaidInvoices.toPayAmount === 0 ? (
                                    t('invoice.paid')
                                ) : (((!unpaidInvoices.sapDocument || (unpaidInvoices?.toPayAmount > 0 &&  unpaidInvoices?.invoiceGrossAmount > 15000)) && this.isUserInRole('ROLE_FLEET')) ||
                                     (unpaidInvoices.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')) ||
                                    ((!unpaidInvoices.sapDocument || unpaidInvoices.toPayAmount >= 15000 ) && !this.isUserInRole('ROLE_FLEET') )
                                ) ? (
                                    t('invoice.payTraditional')
                                ) : (( unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && unpaidInvoices.invoiceGrossAmount <= 15000 &&  this.isUserInRole('ROLE_FLEET') ) ||
                                    (unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && unpaidInvoices.toPayAmount < 15000 && !this.isUserInRole('ROLE_FLEET') )
                                  // ||  (unpaidInvoices.sapDocument && unpaidInvoices.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL'))
                                ) ? (
                                    <span>{`${t('invoice.pay')} ${t('invoice.pay24')}`}</span>
                                ) : null
                            }
                            handleClick={(e) => {
                                e.preventDefault();
                                if (unpaidInvoices.toPayAmount === 0) {
                                } else if ((!unpaidInvoices.sapDocument || (unpaidInvoices?.toPayAmount > 0 &&  unpaidInvoices?.invoiceGrossAmount > 15000)) &&  this.isUserInRole('ROLE_FLEET') ) {
                                    this.setState({invoiceTraditionalDialog: true});
                                }
                                else if((unpaidInvoices.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL'))){
                                    this.setState({invoiceTraditionalDialog: true});
                                }
                                else if ((!unpaidInvoices.sapDocument || unpaidInvoices.toPayAmount >= 15000 ) &&  !this.isUserInRole('ROLE_FLEET')) {
                                } else if (
                                    (unpaidInvoices.sapDocument &&
                                        unpaidInvoices.toPayAmount > 0 &&
                                        unpaidInvoices.invoiceGrossAmount <= 15000 &&
                                        this.isUserInRole('ROLE_FLEET')) ||
                                    (
                                        unpaidInvoices.sapDocument &&
                                        unpaidInvoices.toPayAmount > 0 &&
                                        unpaidInvoices.toPayAmount < 15000 &&
                                        !this.isUserInRole('ROLE_FLEET')
                                    )

                                ) {
                                    this.initPayment(unpaidInvoices);
                                }
                            }}
                            disabled={this.user?.agreementSapRole === 'FLOTA' && (!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                !this.isUserHasPermission('PERMISSION_EDIT_INVOICES'))}
                        />
                    </BannerComponent>
                );
            } else if (!!unpaidInvoices && unpaidInvoices.count > 1) {
                return (
                    <BannerComponent
                        key={'header-banner'}
                        label={t('profile.unpaidInvoices', { invoicesCount: unpaidInvoices.count })}
                        iconSvg='ico_red_banner_alert_icon'
                        iconSide='left'
                        rendered={this.state.renderBanner}
                        variant='red-banner'
                        ignoreRightIconItems
                    >
                        <ActionButton
                            key={`pay-invoice-button`}
                            label={t('profile.goToInvoiceList')}
                            variant={'button blue pay-invoice-button'}
                            handleClick={() => (window.location.href = '#/invoice-list')}
                            iconSvg='ico_right_arrow_white'
                            iconSide='left'
                            disabled={this.user?.agreementSapRole === 'FLOTA' && (!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                !this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES'))}
                        />
                    </BannerComponent>
                );
            } else {
                return null;
            }
        }
    }

    renderNewsCard() {
        const { t } = this.props;
        if (this.state.newsfeed && this.state.newsfeed?.length > 0) {
            return (
                <div>
                    {this.state.newsfeed.map((item, index) => {
                        const date = item.date
                            ? `${new Date(item.date).getDate()} ${this.props.t(
                                `monthsDeclination.${new Date(item.date).getMonth()}`
                            )} ${new Date(item.date).getFullYear()}`
                            : '';
                        return (
                            <div
                                className={item.url ? 'row newsfeed-row clickable' : 'row newsfeed-row'}
                                key={`newsfeed-${index}`}
                                onClick={item.url ? () => window.open(item.url) : () => { }}
                            >
                                <div className='col-width-auto newsfeed-image-col' key={`newsfeed-photo-${index}`}>
                                    <img
                                        key={`newsfeed-photo-${index}`}
                                        alt={t('news.alt')}
                                        src={item.thumbinalUrl}
                                        className='newsfeed-image'
                                    />
                                </div>
                                <div className='col-width-flex' key={`newsfeed-title-${index}`}>
                                    <div className='content-row'>
                                        <label className='date-label'>{date}</label>
                                        <div className='content-label'>{item.title}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            );
        }
    }

    renderDetails() {
        const { t } = this.props;
        const hybridCardUser = (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK');

        return (
            <React.Fragment>
                <DivContainer colClass='dashboard-link-container'>
                    <DivContainer colClass='row'>
                        {this.user && this.user.agreementType === 'CASH' ? (
                            <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-4'>

                                <Card header={this.renderInvoiceHeader()} className='invoice-container right-icon-header'>
                                    {this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES') && (
                                        <BlockUi
                                            tag='div'
                                            blocking={this.state.loadingLastInvoice}
                                            loader={this.loader}
                                            loaderType='small-loader'
                                            horizontal
                                        >
                                            <DivContainer colClass='col-12'>
                                                <span className='label'>{t('invoice.lastInvoiceAmount')}</span>
                                            </DivContainer>
                                            <DivContainer colClass='col-12'>
                                                <h1 className='invoice-last-value'>{currency(this.state.lastInvoiceAmount?.amount, 2)}</h1>
                                            </DivContainer>
                                            <DivContainer colClass='col-12'>
                                                <div className='invoice-buttons col-12'>
                                                    <div>
                                                        <ActionButton
                                                            label={t('transaction.listName')}
                                                            variant='button transactions-button white'
                                                            href={'/#/transaction-list'}
                                                            iconSvg='ico_dashboard_transactions'
                                                            iconSide='left'
                                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                !this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS')}
                                                        />
                                                        <ActionButton
                                                            label={t('invoice.listName')}
                                                            variant='button invoices-button white'
                                                            href={'/#/invoice-list'}
                                                            iconSvg='ico_dashboard_invoices'
                                                            iconSide='left'
                                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                !this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES')}
                                                        />
                                                    </div>
                                                </div>
                                            </DivContainer>
                                        </BlockUi>
                                    )}
                                </Card>
                            </DivContainer>
                        ) : this.user && this.user.agreementType === 'PREPAID' ? (
                            <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-8'>
                                <Card header={this.renderBalanceHeader()} className='balance-container right-icon-header'>
                                    <BlockUi
                                        tag='div'
                                        blocking={this.state.loadingBalance}
                                        loader={this.loader}
                                        loaderType='small-loader card-loader'
                                        horizontal
                                    >
                                        {this.isUserHasAnyPermission('PERMISSION_VIEW_START', 'PERMISSION_EDIT_START') && (
                                            <div className='row'>
                                                <div className='balance-available-prepaid col-8'>
                                                    <span className='label'>{t('balance.remainingLimit')}</span>
                                                    <span className={`value${this.state.balance.remainingLimit < 0 ? ' negative' : ''}`}>
                                                        <NumberFormat
                                                            value={this.state.balance.remainingLimit}
                                                            className='value'
                                                            displayType={'text'}
                                                            thousandSeparator=' '
                                                            decimalSeparator=','
                                                            fixedDecimalScale
                                                            decimalScale={2}
                                                            suffix={` ${t('currency.pln')}`}
                                                            renderText={(value, props) => value}
                                                        />
                                                    </span>
                                                </div>
                                                <div className='balance-buttons-prepaid col-sm-4 col-xs-12'>
                                                    <div className='row'>
                                                        <ActionButton
                                                            label=''
                                                            renderLabel={() => {
                                                                return (
                                                                    <div>
                                                                        <div className='row'>
                                                                            <span className='col-12'>{t('balance.topUpAccount')}</span>
                                                                        </div>
                                                                        <div className='row'>
                                                                            <span className='payment-method col-12'>Przelewy 24</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }}
                                                            handleClick={(e) => {
                                                                e.preventDefault();
                                                                this.setState({
                                                                    showTopUpDialog: true,
                                                                    topUpDialogConfirmation: false,
                                                                });
                                                            }}
                                                            variant='button transactions-button blue'
                                                            iconSvg='ico_dashboard_transactions'
                                                            iconSide='left'
                                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_START')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='balance-granted-used-bank col-sm-8 col-xs-12'>
                                                    <div className='balance-granted-used'>
                                                        <div className='balance-granted'>
                                                            <span className='label'>{t('balance.lastPayment')}</span>
                                                            <span className='value'>
                                                                {!!this.state.balance.settlementDocs &&
                                                                    this.state.balance.settlementDocs.length > 0 ? (
                                                                    <NumberFormat
                                                                        value={this.state.balance.settlementDocs[0].value}
                                                                        className='value'
                                                                        displayType={'text'}
                                                                        thousandSeparator=' '
                                                                        decimalSeparator=','
                                                                        fixedDecimalScale
                                                                        decimalScale={2}
                                                                        suffix={` ${t('currency.pln')}`}
                                                                        renderText={(value, props) => value}
                                                                    />
                                                                ) : (
                                                                    <div className='value'>-</div>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='balance-bank-account'>
                                                        <span className='label'>{t('balance.bankAccount')}</span>
                                                        <span className='value'>{this.user.agreementBankAccountNumber}</span>
                                                        <CopyToClipboard
                                                            text={
                                                                !!this.user.agreementBankAccountNumber
                                                                    ? this.user.agreementBankAccountNumber.replace(/^\D+/g, '')
                                                                    : ''
                                                            }
                                                            onCopy={() => this.showSuccessMessage(t('balance.copyBankAccountSuccess'))}
                                                        >
                                                            <img
                                                                src='/images/ico_copy.svg'
                                                                className='card-icon'
                                                                alt={t('balance.copyBankAccount')}
                                                            />
                                                        </CopyToClipboard>
                                                    </div>
                                                </div>
                                                <div className='balance-buttons col-sm-4 col-xs-12'>
                                                    <div className='row'>
                                                        <ActionButton
                                                            label={t('transaction.listName')}
                                                            variant='button transactions-button white'
                                                            href={'/#/transaction-list'}
                                                            iconSvg='ico_dashboard_transactions'
                                                            iconSide='left'
                                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                !this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS')}
                                                        />
                                                        <ActionButton
                                                            label={t('invoice.listName')}
                                                            variant='button invoices-button white'
                                                            href={'/#/invoice-list'}
                                                            iconSvg='ico_dashboard_invoices'
                                                            iconSide='left'
                                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                !this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </BlockUi>
                                </Card>
                            </DivContainer>
                        ) : (
                            <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-8'>
                                <Card header={this.renderBalanceHeader()} className='balance-container right-icon-header'>
                                    {this.user && (
                                        (this.user.agreementSapRole === 'FLOTA' && this.isUserHasAnyPermission('PERMISSION_VIEW_START', 'PERMISSION_EDIT_START')) ||
                                        this.user.agreementSapRole === 'HURT' ||
                                        this.user.agreementSapRole === 'FRANCZYZA' ||
                                        this.user.agreementSapRole === 'HURT EPT'
                                    ) && (
                                            <BlockUi
                                                tag='div'
                                                blocking={this.state.loadingBalance}
                                                loader={this.loader}
                                                loaderType='small-loader card-loader'
                                                horizontal
                                            >
                                                <div className='row'>
                                                    <div className='balance-available col-12'>
                                                        <span className='label'>{t('balance.remainingLimit')}</span>
                                                        <span className={`value${this.state.balance.remainingLimit < 0 ? ' negative' : ''}`}>
                                                            <NumberFormat
                                                                value={this.state.balance.remainingLimit}
                                                                className='value'
                                                                displayType={'text'}
                                                                thousandSeparator=' '
                                                                decimalSeparator=','
                                                                fixedDecimalScale
                                                                decimalScale={2}
                                                                suffix={` ${t('currency.pln')}`}
                                                                renderText={(value, props) => value}
                                                            />
                                                        </span>
                                                    </div>
                                                    <div className='balance-granted-used-bank col-sm-8 col-xs-12'>
                                                        <div className='balance-granted-used'>
                                                            <div className='balance-granted'>
                                                                <span className='label'>{t('balance.creditLimit')}</span>
                                                                <span className='value'>
                                                                    <NumberFormat
                                                                        value={this.state.balance.creditLimit}
                                                                        className='value'
                                                                        displayType={'text'}
                                                                        thousandSeparator=' '
                                                                        decimalSeparator=','
                                                                        fixedDecimalScale
                                                                        decimalScale={2}
                                                                        suffix={` ${t('currency.pln')}`}
                                                                        renderText={(value, props) => value}
                                                                    />
                                                                </span>
                                                            </div>
                                                            <div className='balance-used'>
                                                                <span className='label'>{t('balance.used')}</span>
                                                                <span className='value'>
                                                                    <NumberFormat
                                                                        value={this.state.balance.creditLimit - this.state.balance.remainingLimit}
                                                                        className='value'
                                                                        displayType={'text'}
                                                                        thousandSeparator=' '
                                                                        decimalSeparator=','
                                                                        fixedDecimalScale
                                                                        decimalScale={2}
                                                                        suffix={` ${t('currency.pln')}`}
                                                                        renderText={(value, props) => value}
                                                                    />
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className='balance-bank-account'>
                                                            <span className='label'>{t('balance.bankAccount')}</span>
                                                            <span className='value'>{this.user.agreementBankAccountNumber}</span>
                                                            <CopyToClipboard
                                                                text={
                                                                    !!this.user.agreementBankAccountNumber
                                                                        ? this.user.agreementBankAccountNumber.replace(/^\D+/g, '')
                                                                        : ''
                                                                }
                                                                onCopy={() => this.showSuccessMessage(t('balance.copyBankAccountSuccess'))}
                                                            >
                                                                <img
                                                                    src='/images/ico_copy.svg'
                                                                    className='card-icon'
                                                                    alt={t('balance.copyBankAccount')}
                                                                />
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                    <div className='balance-buttons col-sm-4 col-xs-12'>
                                                        <div className='row'>
                                                            <ActionButton
                                                                label={t('additionalServices.label')}
                                                                variant='button transactions-button white'
                                                                href={'/#/cards'}
                                                                iconSvg='ico_car_highways_btn'
                                                                iconSide='left'
                                                                handleClick={() => this.saveCookie(`your-cards-list-activeIndex`, 6)}
                                                                disabled={this.user?.agreementSapRole === 'FLOTA' && (!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                    !this.isUserHasAnyPermission('PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS'))}
                                                                rendered={this.isUserInRole('ROLE_FLEET') && this.user && this.user.agreementType === 'CASHLESS' }
                                                            />
                                                            <ActionButton
                                                                label={
                                                                    this.user &&
                                                                        (this.user.agreementSapRole === 'HURT' ||
                                                                            this.user.agreementSapRole === 'FRANCZYZA' ||
                                                                            this.user.agreementSapRole === 'HURT EPT')
                                                                        ? t('sidebar.orders')
                                                                        : t('transaction.listName')
                                                                }
                                                                variant='button transactions-button white'
                                                                href={
                                                                    this.user &&
                                                                        (this.user.agreementSapRole === 'HURT' ||
                                                                            this.user.agreementSapRole === 'FRANCZYZA' ||
                                                                            this.user.agreementSapRole === 'HURT EPT')
                                                                        ? '/#/orders'
                                                                        : '/#/transaction-list'
                                                                }
                                                                iconSvg='ico_dashboard_transactions'
                                                                iconSide='left'
                                                                disabled={this.user?.agreementSapRole === 'FLOTA' && (!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                    !this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS'))}
                                                            />
                                                            <ActionButton
                                                                label={t('invoice.listName')}
                                                                variant='button invoices-button white'
                                                                href={'/#/invoice-list'}
                                                                iconSvg='ico_dashboard_invoices'
                                                                iconSide='left'
                                                                disabled={this.user?.agreementSapRole === 'FLOTA' && (!this.isUserHasPermission('PERMISSION_EDIT_START') ||
                                                                    !this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES'))}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </BlockUi>
                                        )
                                    }
                                </Card>
                            </DivContainer>
                        )}
                        {this.user && this.user.agreementType === 'CASH' ? (
                            <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-4'>
                                <Card header={this.renderFleetCardsHeader()} className='fleet-card-container  right-icon-header'>
                                    {this.isUserHasAnyPermission('PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS') && (
                                        <DivContainer>
                                            <DivContainer colClass='col-12'>
                                                <span className='label'>{t('cash-cards.desc')}</span>
                                            </DivContainer>

                                            <DivContainer colClass='col-12'>
                                                <DivContainer colClass='fleet-card-button'>
                                                    <ActionButton
                                                        label={t('cash-cards.order')}
                                                        variant='button white'
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                        handleClick={this.handleOrderCardDialogOpen}
                                                        disabled={!this.isUserHasPermission('PERMISSION_EDIT_START') || !this.isUserHasPermission('PERMISSION_FULL_ACCESS_ORDERS')}
                                                    />
                                                </DivContainer>
                                            </DivContainer>
                                        </DivContainer>
                                    )}
                                </Card>
                            </DivContainer>
                        ) : null}

                         <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-4'>
                            <Card header={this.renderProfileHeader()} className='profile-container right-icon-header'>
                                {this.user && (
                                    (this.user.agreementSapRole === 'FLOTA' && this.isUserHasAnyPermission('PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE')) ||
                                    this.user.agreementSapRole === 'HURT' ||
                                    this.user.agreementSapRole === 'FRANCZYZA' ||
                                    this.user.agreementSapRole === 'HURT EPT'
                                ) && (
                                        <div>
                                            <div className='profile-own'>
                                                <div className='tooltip-label start-page'>
                                                    <TooltipComponent
                                                        id='start-tooltip-label-id'
                                                        key='start-tooltip-label-id'
                                                        visible={this.state.tooltipVisibile}
                                                        content={
                                                            this.user && this.user.agreementType === 'CASHLESS'
                                                                ? t('profile.ownCashelessTooltip')
                                                                : this.user && this.user.agreementType === 'PREPAID'
                                                                    ? t('profile.ownPrepaidTooltip') :
                                                                    this.user.agreementType === 'CASH' && hybridCardUser === true ?
                                                                    t('profile.ownHybridCashTooltip') 
                                                                    : t('profile.ownCashTooltip')
                                                        }
                                                        eventListeners={[
                                                            {
                                                                eventName: 'mouseleave',
                                                                fnc: this.handleHideTooltip,
                                                                eventElementId: 'ico_help_input_label_id',
                                                            },
                                                            {
                                                                eventName: 'mouseenter',
                                                                fnc: this.handleShowTooltip,
                                                                eventElementId: 'ico_help_input_label_id',
                                                            },
                                                        ]}
                                                    />
                                                    <span className='p-label flex-inputs'>
                                                        {t('profile.own')}
                                                        {this.authService.getProfile().agreementSapRole !== 'HURT' &&
                                                            this.authService.getProfile().agreementSapRole !== 'FRANCZYZA' &&
                                                            this.authService.getProfile().agreementSapRole !== 'HURT EPT' ? (
                                                            <MenuItemIcon
                                                                alt=''
                                                                key={'menu-item-key'}
                                                                id='ico_help_input_label_id'
                                                                className='icon-svg right-label flex-inputs'
                                                                iconSvg={'ico_help_input_label_blue'}
                                                                eventListeners={[
                                                                    {
                                                                        eventName: 'mouseenter',
                                                                        fnc: this.handleShowTooltipMenuItem,
                                                                        eventElementId: 'ico_help_input_label_id',
                                                                    },
                                                                ]}
                                                            />
                                                        ) : null}
                                                    </span>
                                                </div>
                                                <span className='value'>
                                                    {this.user && this.user.agreementType === 'CASHLESS'
                                                        ? t('profile.cashlessLabel')
                                                        : this.user && this.user.agreementType === 'PREPAID'
                                                            ? t('profile.prepaidLabel')
                                                            : this.user && this.user.agreementSapRole === 'HURT EPT'
                                                                ? t('profile.esppolLabel')
                                                                : this.user && this.user.agreementSapRole === 'HURT'
                                                                    ? t('profile.wholesaleLabel')
                                                                    : this.user && this.user.agreementSapRole === 'FRANCZYZA'
                                                                        ? t('profile.franchiseLabel') :
                                                                        this.user && this.user.agreementType === 'CASH' && hybridCardUser === true ?
                                                                        t('profile.cashHybridLabel') 
                                                                        : t('profile.cashLabel')}
                                                    <br />
                                                    {this.user.agreementSapRole !== 'HURT' &&
                                                        this.user.agreementSapRole !== 'FRANCZYZA' &&
                                                        this.user.agreementSapRole !== 'HURT EPT'
                                                        ? 'Moya Firma'
                                                        : ''}
                                                </span>
                                            </div>
                                            <div className='profile-agreement-status col-12'>
                                                <span className='label'>{t('agreement.statusLabel')}</span>
                                                <span className={this.user.agreementStatus === 'ACTIVE' ? 'value active' : 'value inactive'}>
                                                    <MenuItemIcon
                                                        alt=''
                                                        key={'agreement-status--key'}
                                                        className={`icon-svg left`}
                                                        iconSvg={
                                                            this.user.agreementStatus === 'ACTIVE' ? 'ico_agreement_active' : 'ico_agreement_inactive'
                                                        }
                                                    />
                                                    {t(`EcAgreementStatus.${this.user.agreementStatus}`)}
                                                </span>
                                            </div>
                                            <div className='profile-ph col-12'>
                                                <span className='label'>{t('agreement.saleRep')}</span>
                                                <span className='value'>
                                                    {this.user.agreementSaleRepName}
                                                    <br />
                                                    {this.user.agreementSaleRepEmail}
                                                    <br />
                                                    {this.user.agreementSaleRepPhoneNumber}
                                                </span>
                                            </div>
                                        </div>
                                    )
                                }
                            </Card>
                        </DivContainer>
                        <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-8 news-card'>
                            <Card
                                header={this.renderNewsHeader()}
                                className='right-icon-header'
                                rendered={!this.state.loadingNewsfeedError}
                            >
                                <BlockUi
                                    tag='div'
                                    blocking={this.state.loadingNewsfeed}
                                    loader={this.loader}
                                    loaderType='small-loader'
                                    horizontal
                                >
                                    {this.renderNewsCard()}
                                </BlockUi>
                            </Card>
                        </DivContainer>
                        <DivContainer colClass='col-12 col-xs-12 col-sm-12 col-md-4'>
                            <Card className='banner-offer-for-you' header={this.renderOffersHeader()}>
                                {
                                    <CarouselComponent
                                        elements={this.state.banners}
                                        switchTime={this.state.bannerSwitchTime}
                                        authToken={this.authService.getToken()}
                                       // onBannerClick={(banner, idx) => console.log('Kliknięto baner:', banner, idx)}
                                    />
                                }

                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }
}

export default withTranslation()(StartContainer);
